"use client";

import { forwardRef } from "react";
import styled from "styled-components";
import { backgroundColorLevelCurrent } from "@churchofjesuschrist/eden-style-constants";
import { sharedCheckCss } from "../utils/sharedCss";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyRadio = styled.input.attrs({
  type: "radio"
}).withConfig({
  componentId: "sc-bv55qe-0"
})(["", ";border-radius:50%;&:checked{box-shadow:inset 0px 0px 0px 3px ", ";}"], sharedCheckCss, backgroundColorLevelCurrent);

/**
 * The `Radio` component is used when there are two or more options and the user must choose only one.
 * @param {object} props - The component props
 * @param {boolean} [props.checked] - The checked state for controlled use.
 * @param {boolean} [props.defaultChecked] - Default checked state for uncontrolled use.
 * @param {boolean} [props.disabled] - Makes the input not mutable, focusable, or even submitted with the form.
 * @param {string} [props.name] - Used to reference the input in JavaScript, or to reference form data after a form is submitted.
 * @param {Function} [props.onChange] - Callback to execute when the Radio is toggled.
 * @param {boolean} [props.required] - Whether the input is required to be filled out to validate.
 * @param {string} [props.value] - Value of the Radio.
 * @param {React.Ref} ref - Ref forwarded to the underlying element.
 * @returns {React.ReactElement} The Radio component
 */
const RadioComponent = (props, ref) => /*#__PURE__*/_jsx(InternalUseOnlyRadio, {
  ref: ref,
  ...props
});
const Radio = /*#__PURE__*/forwardRef(RadioComponent);
Radio.displayName = "Radio";

// Custom property for the FormField to consume
Radio.isInput = true;
export default Radio;